import {
    BASKET_SCOPE_DEV,
    BASKET_SCOPE_QA,
    DEFAULT_POLICY,
    DEVELOPMENT_ENVIRONMENT,
    OAuthTokenScopes,
    WISHLIST_SCOPE_DEV,
    WISHLIST_SCOPE_PROD,
    WISHLIST_SCOPE_QA,
    WZ_SCOPE_DEV,
    WZ_SCOPE_PROD,
    WZ_SCOPE_QA,
} from '@os-components';

export const authDev: OAuthTokenScopes = {
    clientId: '5151a03f-4584-417a-b39d-fa58f55d4737',
    policy: DEFAULT_POLICY,
    scopes: [BASKET_SCOPE_DEV, WZ_SCOPE_DEV, WISHLIST_SCOPE_DEV],
};
export const authQa: OAuthTokenScopes = {
    clientId: '9ac0d555-e631-49bf-b2bf-c20c17c717f0',
    policy: DEFAULT_POLICY,
    scopes: [BASKET_SCOPE_QA, WZ_SCOPE_QA, WISHLIST_SCOPE_QA],
};

// TODO Ändern mit richtige wenn es gibt prod auth scope
export const authProd: OAuthTokenScopes = {
    // OIDC deaktivieren wegen Login Issue
    clientId: 'b25118eb-ab3a-4bbf-b7ac-75157f02b1bc',
    policy: DEFAULT_POLICY,
    scopes: [WZ_SCOPE_PROD, WISHLIST_SCOPE_PROD],
};

export const LOCAL_BASE_CONFIG = {
    ...DEVELOPMENT_ENVIRONMENT,
    baseURLs: {
        ...DEVELOPMENT_ENVIRONMENT.baseURLs,
        href: '/os/ecs/',
        api: {
            ...DEVELOPMENT_ENVIRONMENT.baseURLs.api,
            domain: 'https://www.sew-d.de',
            path: '/os/api/ecs',
        },
    },
    auth: authDev,
    tokens: {
        accessory:
            'A39ACB2EAEA34C86A64B410B86A39B433E52823AE08B405CB5705CE833D4C27E225F2E70DB1C4FDAB4BC8B64131C1887',
    },
    // needs to be listed after `...DEVELOPMENT_ENVIRONMENT`
    useCMP: false,
    apiGateway: {
        ...DEVELOPMENT_ENVIRONMENT.apiGateway,
        dmz: {
            ...DEVELOPMENT_ENVIRONMENT.apiGateway.dmz,
            apiKey: '91474a7f-20ec-4bd1-82e8-e4a635cf7165',
            paths: {
                drSerialnumberOcr: '/dr-serialnumber-ocr/1.1.0/serialnumber',
            },
        },
    },
};

export const href = '/os/ecs/';
export const path = '/os/api/ecs';
